import React, { useEffect } from "react";

import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import styles from "./styles";
import withStyles from "@material-ui/core/styles/withStyles";

const EasySwitch = (props) => {
  const { propName } = props;
  const setPropMounted = props.connectForm.setPropMounted;

  useEffect(() => {
    setPropMounted(propName, true);
    return () => {
      setPropMounted(propName, false);
    };
  }, [setPropMounted, propName]);

  const disabled = props.disabled != null ? props.disabled : false;
  const checked = props.connectForm.getValue(propName);
  const { classes } = props;
  return (
    <div className={classes.block}>
      <FormControlLabel
        control={
          <Switch
            checked={checked}
            onChange={() => props.connectForm.change(!checked, propName)}
            disabled={disabled}
            value={checked}
            color="primary"
          />
        }
        classes={{
          label: classes.label,
        }}
        label={
          <span>
            {props.connectForm.getLabel(propName) + " "}
            {props.connectForm.isRequired(propName) ? (
              <span style={{ color: "red" }}>*</span>
            ) : (
              ""
            )}
          </span>
        }
      />
    </div>
  );
};

export default withStyles(styles)(EasySwitch);
